import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/tw-merge';

/** Marketing section shell — full-bleed background + top hairline options. */
export function UiSection({
    id,
    background = 'page',
    borderTop = false,
    className,
    children,
}: {
    id?: string;
    background?: 'page' | 'surface';
    borderTop?: false | 'hairline' | 'hairline-2';
    className?: string;
    children: ReactNode;
}) {
    return (
        <section
            id={id}
            className={cn(
                'scroll-mt-16',
                background === 'surface' ? 'bg-surface' : 'bg-page',
                borderTop === 'hairline' && 'border-t border-hairline',
                borderTop === 'hairline-2' && 'border-t border-hairline-2',
                className,
            )}
        >
            {children}
        </section>
    );
}
